module.exports = __webpack_public_path__ + "static/media/poster.ee1b1f51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Drone/poster.jpg
// module id = 319
// module chunks = 0